var exports = {
  "k": "xe7b6e3d6--a09732--container",
};

module.exports = exports;
